module.exports = __webpack_public_path__ + "img/logo_ico.30474694.svg";